import colorfull from "dan-api/palette/colorfull";
import { makeStyles } from "tss-react/mui";
import { darken, alpha, lighten } from "@mui/material/styles";
import {
  gradientBgLight,
  gradientBgDark,
} from "containers/Templates/appStyles-jss";
import images from "dan-api/images/photos";
import { blue, green, red } from "@mui/material/colors";

const useStyles = makeStyles()((theme, _params, classes) => ({
  rootCounter: {
    flexGrow: 1,
  },

  bg: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    backgroundImage: `linear-gradient(-45deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 33%, ${theme.palette.secondary.dark} 100%);`,
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      "& span": {
        // color: theme.palette.secondary.light,
        color: "#fff",
        fontWeight: "800",
        fontSize: "22px !important",
      },
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "15px !important",
      color: "#fff",
    },
    borderRadius: theme.rounded.small,
  },
  awarenessTitle: {
    fontSize: "12px",
    color: "#fff",
  },
  rootCounterFull: {
    flexGrow: 1,
    "& span": {
      fontSize: "24px !important",
    },
  },
  rootContact: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",
    "& header + div": {
      padding: "8px !important",
    },
  },
  divider: {
    margin: `${theme.spacing(3)} 0`,
  },
  dividerBig: {
    margin: `${theme.spacing(2)} 0`,
  },
  centerItem: {},
  smallTitle: {
    padding: `0 ${theme.spacing(2)}`,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  secondaryWrap: {
    padding: `1px ${theme.spacing(2)}`,
    borderRadius: 4,
    justifyContent: "space-around",
    [`& > .${classes.centerItem}`]: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    "& li": {
      marginBottom: 30,
    },
    [`& .${classes.chip}`]: {
      top: 50,
      position: "absolute",
      fontSize: 11,
      fontWeight: 400,
    },
  },
  bigResume: {
    marginBottom: theme.spacing(5),
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      height: 160,
      display: "block",
    },
    "& li": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      [theme.breakpoints.down("sm")]: {
        paddingRight: 0,
        paddingBottom: theme.spacing(2),
        width: "50%",
        float: "left",
      },
    },
    [`& .${classes.avatar}`]: {
      [theme.breakpoints.up("sm")]: {
        width: 50,
        height: 50,
        "& svg": {
          fontSize: 32,
        },
      },
    },
  },
  liItemChild: {
    justifyContent: "start !important",
    backgroundColor: "#dfdef9 !important",
  },
  bigResumeCount: {
    marginBottom: theme.spacing(1),
    justifyContent: "center",
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      height: 160,
      display: "block",
    },
    "& li": {
      display: "flex",
      alignItems: "center",
      width: "200px",
      padding: " 0 35px",
      justifyContent: "end",
      [theme.breakpoints.down("sm")]: {
        paddingRight: 0,
        paddingBottom: theme.spacing(2),
        width: "50%",
        float: "left",
      },
      maxWidth: "100%",
      width: "50%",
      backgroundColor: "#8ac4f1",
    },
    [`& .${classes.avatar}`]: {
      [theme.breakpoints.up("sm")]: {
        width: 50,
        height: 50,
        "& svg": {
          fontSize: 32,
        },
      },
    },
  },
  sm: {},
  mc: {},
  avatar: {
    marginRight: theme.spacing(1),
    boxShadow: theme.glow.light,
    "& svg": {
      fontSize: 24,
    },
    [`&.${classes.sm}`]: {
      width: 30,
      height: 30,
    },
    [`&.${classes.mc}`]: {
      width: 24,
      height: 24,
      top: 0,
      left: 8,
      marginRight: 0,
    },
  },
  pinkAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[0],
  },
  pinkText: {
    color: colorfull[0],
    "& svg": {
      fill: colorfull[0],
    },
  },
  purpleAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[1],
  },
  purpleText: {
    color: colorfull[1],
    "& svg": {
      fill: colorfull[1],
    },
  },
  blueAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[2],
  },
  blueText: {
    color: colorfull[26],
    fontSize: "20px !important",
    "& svg": {
      fill: colorfull[2],
    },
  },
  tealAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[3],
  },
  tealText: {
    color: colorfull[3],
    "& svg": {
      fill: colorfull[3],
    },
  },
  orangeAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[4],
  },
  orangeText: {
    color: colorfull[4],
    "& svg": {
      fill: colorfull[4],
    },
  },
  indigoAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[6],
  },
  greenAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[5],
  },
  indigoText: {
    color: colorfull[6],
    "& svg": {
      fill: colorfull[6],
    },
  },
  pinkProgress: {
    color: colorfull[0],
    "& div": {
      backgroundColor: colorfull[0],
    },
  },
  greenProgress: {
    color: colorfull[5],
    "& div": {
      backgroundColor: colorfull[5],
    },
  },
  orangeProgress: {
    color: colorfull[4],
    "& div": {
      backgroundColor: colorfull[4],
    },
  },
  purpleProgress: {
    color: colorfull[1],
    "& div": {
      backgroundColor: colorfull[1],
    },
  },
  blueProgress: {
    color: colorfull[2],
    "& div": {
      backgroundColor: colorfull[2],
    },
  },
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  chip: {
    margin: "8px 0 8px auto",
    color: "#FFF",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  textCenter: {
    textAlign: "center",
  },
  textRight: {
    textAlign: "right",
  },
  red: {},
  orange: {},
  indigo: {},
  purple: {},
  lime: {},
  taskIcon: {
    display: "block",
    textAlign: "center",
    margin: "0 10px",
    color: theme.palette.primary.main,
  },
  productPhoto: {
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  done: {},
  listItem: {
    padding: 5,
    background: theme.palette.background.paper,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? darken(theme.palette.background.paper, 0.3)
          : theme.palette.secondary.light,
    },
    [`&.${classes.done}`]: {
      textDecoration: "line-through",
    },
  },
  title: {},
  subtitle: {},
  styledPaper: {
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.secondary.dark
        : theme.palette.secondary.main,
    padding: 20,
    [`& .${classes.title}, & .${classes.subtitle}`]: {
      color: theme.palette.common.white,
    },
  },
  progressWidget: {
    marginTop: 20,
    background: theme.palette.secondary.dark,
    "& div": {
      background: theme.palette.primary.light,
    },
  },
  chipProgress: {
    marginTop: 20,
    background: theme.palette.primary.light,
    color: theme.palette.secondary.main,
    "& div": {
      background: colorfull[4],
      color: theme.palette.common.white,
    },
  },
  taskStatus: {
    display: "flex",
    alignItems: "center",
    "& a": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
  },
  counterIcon: {
    color: theme.palette.common.white,
    opacity: 0.7,
    fontSize: 84,
  },
  progressCircle: {
    borderRadius: "50%",
    background: lighten(theme.palette.divider, 0.7),
  },
  itemCarousel: {
    textAlign: "center",
    "& img": {
      margin: "10px auto",
    },
  },
  albumRoot: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    height: "auto",
    [theme.breakpoints.up("sm")]: {
      width: 500,
    },
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
  img: {
    maxWidth: "none",
  },
  mapWrap: {
    position: "relative",
    overflow: "hidden",
    height: 200,
    "& > div": {
      height: "100%",
    },
  },
  address: {
    display: "block",
  },
  carouselItem: {
    margin: "0 5px",
    boxShadow: theme.shadows[3],
    borderRadius: theme.rounded.medium,
    overflow: "hidden",
    height: 250,
    padding: "20px 20px",
    position: "relative",
  },
  iconBg: {
    color: theme.palette.common.white,
    opacity: 0.25,
    position: "absolute",
    bottom: 10,
    right: 10,
    fontSize: 96,
  },
  carouselTitle: {
    color: theme.palette.common.white,
    display: "flex",
    flexDirection: "column",
    fontWeight: 500,
    fontSize: 20,
    marginBottom: theme.spacing(10),
  },
  carouselDesc: {
    color: theme.palette.common.white,
  },
  chartWrap: {
    // overflow: "auto",
    marginTop: theme.spacing(2),
  },
  chartFluid: {
    width: "100%",
    minWidth: 400,
    height: 300,
    position: "relative",
    marginLeft: theme.spacing(1) * -3,
  },
  tabNotif: {
    "& > span": {
      top: -20,
      right: 0,
    },
  },
  button: {
    marginRight: theme.spacing(1),
    width: "100%",
  },
  wrapperDate: {
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  calendarWrap: {
    [theme.breakpoints.up("sm")]: {
      maxWidth: 300,
    },
    zIndex: 1,
    background:
      theme.palette.mode === "dark"
        ? theme.palette.secondary.dark
        : theme.palette.secondary.main,
    "& > div": {
      border: "none",
      background: "none",
      width: "auto",
      color: "#FFF",
      padding: theme.spacing(1),
      "& button": {
        color: "#FFF",
        fontSize: 12,
        borderRadius: theme.rounded.big,
        padding: theme.spacing(1),
        background: "none",
        '&[class*="navigation__label"]': {
          fontSize: 18,
        },
        '&[class*="tile--active"]': {
          background: theme.palette.primary.main,
          boxShadow: theme.glow.light,
        },
        '&[class*="tile--now"]': {
          background: theme.palette.primary.main,
          boxShadow: theme.glow.light,
        },
        '&[class*="__year-view"]': {
          padding: "1em 0.5em",
          margin: "2px 0",
        },
        '&[class*="__day--weekend"]': {
          color: "#FFF",
        },
        '&[class*="__day--neighboringMonth"]': {
          color: "rgba(255,255,255,0.5)",
        },
        "&:hover": {
          background: `${theme.palette.secondary.light} !important`,
          color: theme.palette.secondary.main,
        },
        "&:focus": {
          background: "none !important",
          boxShadow: `0 0 0 1px ${theme.palette.secondary.light}`,
          color: theme.palette.secondary.light,
        },
      },
      '& div[class*="__navigation"] button': {
        minWidth: 0,
        padding: theme.spacing(1),
        height: "auto",
      },
    },
  },
  clockWrap: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    alignItems: "center",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.secondary.dark
        : theme.palette.secondary.main,
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(3),
    },
    "& > time": {
      border: `10px solid ${theme.palette.secondary.main}`,
      boxShadow:
        theme.palette.mode === "dark"
          ? `0 0 0 10px ${alpha(theme.palette.secondary.main, 0.6)}`
          : `0 0 0 10px ${alpha(theme.palette.secondary.light, 0.6)}`,
      borderRadius: "50%",
      "& > div": {
        background: theme.palette.secondary.main,
        border: "none",
      },
    },
    '& [class*="__mark__body"], [class*="__hand__body"]': {
      background: theme.palette.secondary.light,
    },
  },
  today: {
    fontSize: 18,
    margin: theme.spacing(3),
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.light,
  },
  storageInfo: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    "& li": {
      margin: `${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(2)}`,
    },
  },
  buttonReadMore: {
    borderColor: "#FFF",
    color: "#FFF",
    marginTop: theme.spacing(1),
  },
  sliderWrap: {
    height: 360,
    overflow: "hidden",
    [`& .${classes.title}`]: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },
  sliderContent: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: "none",
  },
  mobileStepper: {
    margin: `0 auto ${theme.spacing(4)}`,
    textAlign: "center",
    borderRadius: "0 0 12px 12px",
    [theme.breakpoints.down("md")]: {
      marginBottom: 0,
    },
  },
  downloadInvoice: {
    fontSize: 11,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.main
        : theme.palette.primary.dark,
    textDecoration: "none",
    "& svg": {
      width: "0.5em",
    },
  },
  messages: {
    "& p": {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },
  rootCalculator: {
    width: "100%",
    height: 420,
    padding: theme.spacing(2),
    backgroundImage:
      theme.palette.mode === "dark"
        ? gradientBgDark(theme)
        : gradientBgLight(theme),
    "& button": {
      background: alpha(theme.palette.background.paper, 0.3),
      color: theme.palette.common.white,
      borderRadius: theme.rounded.medium,
    },
  },
  stripped: {
    "& tbody tr:nth-of-type(even)": {
      background:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.grey[900], 0.5)
          : theme.palette.grey[50],
    },
  },
  activityWrap: {
    "& ul:before": {
      content: '""',
      position: "absolute",
      height: "100%",
      left: -2,
      borderLeft: `2px solid ${theme.palette.primary.main}`,
      [theme.breakpoints.up("sm")]: {
        left: 104,
      },
    },
  },
  activityList: {
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  activityText: {
    paddingLeft: theme.spacing(4),
    "& span": {
      fontSize: 12,
      fontWeight: theme.typography.fontWeightMedium,
      whiteSpace: "break-spaces",
    },
    "& p": {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  timeDot: {
    position: "relative",
    "& span": {
      border: `3px solid ${theme.palette.primary.main}`,
      width: 15,
      height: 15,
      borderRadius: "50%",
      position: "absolute",
      background: theme.palette.background.paper,
      top: 0,
      left: -8,
      [theme.breakpoints.up("sm")]: {
        left: 66,
      },
    },
    "& time": {
      fontSize: 12,
      textAlign: "left",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      display: "block",
      paddingLeft: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        textAlign: "right",
        width: 60,
        paddingLeft: 0,
      },
    },
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1) * -2,
  },
  formControlTrade: {
    width: "100%",
    marginTop: theme.spacing(1) * -2,
    marginBottom: theme.spacing(2),
  },
  tradeUp: {
    color: green[500],
    "& svg": {
      fill: green[500],
    },
  },
  tradeDown: {
    color: red[500],
    "& svg": {
      fill: red[500],
    },
  },
  tradeFlat: {
    color: theme.palette.divider,
    "& svg": {
      fill: theme.palette.divider,
    },
  },
  btnArea: {
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between",
      display: "flex",
      alignItems: "center",
    },
    "& button": {
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2),
      },
    },
  },
  walletLabel: {
    marginBottom: theme.spacing(3),
  },
  tabContainer: {
    margin: `0 ${theme.spacing(1) * -3}px`,
    overflow: "hidden",
  },
  rootTable: {
    width: "100%",
    marginTop: "24",
    overflowX: "auto",
  },
  table: {
    minWidth: 400,
  },
  tableLong: {
    minWidth: 900,
  },
  sun: {},
  cloud: {},
  weathercard: {
    borderRadius: theme.rounded.medium,
    position: "relative",
    overflow: "hidden",
    height: 270,
    [theme.breakpoints.down("sm")]: {
      height: 260,
    },
    backgroundColor: theme.palette.common.white,
    backgroundSize: "cover",
    boxShadow: "0px 0px 25px 1px rgba(50, 50, 50, 0.1)",
    animation: "appear 500ms ease-out forwards",
    "& h1": {
      position: "absolute",
      fontWeight: "300",
      fontSize: 80,
      color: theme.palette.common.white,
      bottom: 0,
      left: 35,
      opacity: 0,
      transform: "translateX(150px)",
      animation: "title-appear 500ms ease-out 500ms forwards",
    },
    "& p": {
      position: "absolute",
      fontWeight: 300,
      fontSize: 28,
      color: theme.palette.common.white,
      bottom: 0,
      left: 35,
      animation: "title-appear 1s ease-out 500ms forwards",
    },
    [`&.${classes.sun}`]: {
      backgroundImage: `url(${images[9]})`,
      backgroundPosition: "0 -120px",
    },
    [`&.${classes.cloud}`]: {
      backgroundImage: `url(${images[18]})`,
      backgroundPosition: "0 -120px",
    },
  },
  // app1: {
  //   background: "#9c27b0",
  //   borderRadius: " 12px",
  // },
  // app2: {
  //   background: "rgb(236, 64, 122)",
  //   borderRadius: " 12px",
  // },
  // app3: {
  //   background: "#03a9f4",
  //   boxShadow: " 0 0 10px #1e99ed",
  //   borderRadius: " 12px",
  // },
  appCard: {
    boxShadow: " 6px 3px 12px 0px #4b85ad;",
    borderRadius: " 12px",
  },
  apllicationSection: {
    overflowY: "auto",
    height: "420px",
    padding: "1rem",
    overflowX: "hidden",
  },
  apllicationUserSection: {
    overflowY: "auto",
    height: "400px",
    padding: "1rem",
    overflowX: "hidden",
  },
  resourcesSection: {
    overflowY: "auto",
    height: "420px",
    padding: "1rem",
    overflowX: "hidden",
  },
  resourcesUserSection: {
    overflowY: "auto",
    height: "400px",
    padding: "1rem",
    overflowX: "hidden",
  },
  apllicationSectionTraining: {
    overflowY: "auto",
    height: "520px",
    padding: "1rem",
    overflowX: "hidden",
  },
  apllicationQuizSection: {
    overflowY: "auto",

    padding: "1rem",
    // overflowX: "hidden",
    overflowX: "auto",
    minHeight: "100%",
    height: "350px",
  },
  aplicationTrainingDivSection: {
    display: "flex",
    alignItems: "center",
    margin: "5px",
    maxWidth: "100%",
    boxShadow:
      "0px 1px 3px 0px rgba(142, 142, 142, 0.2),0px 1px 1px 0px rgba(243, 243, 243, 0.14),0px 2px 1px -1px rgba(204, 204, 204, 0.12)",
    // width: "225px",
    border: "0.2px solid #0facc9",
    borderRadius: "7px",
    [theme.breakpoints.down("sm")]: {
      width: 230,
    },
    [theme.breakpoints.down("md")]: {
      width: 230,
    },
    [theme.breakpoints.down("lg")]: {
      width: 250,
    },
    // [theme.breakpoints.down("xl")]: {
    //   width: 195,
    // },
    // width: 182,
  },
  aplicationDivSection: {
    margin: "5px",
    maxWidth: "100%",
    // width: "225px",
    border: "0.2px solid #0facc9",
    borderRadius: "7px",
    [theme.breakpoints.down("sm")]: {
      width: 230,
    },
    [theme.breakpoints.down("md")]: {
      width: 230,
    },
    [theme.breakpoints.down("lg")]: {
      width: 250,
    },
    // [theme.breakpoints.down("xl")]: {
    //   width: 195,
    // },
    width: 182,
  },
  awarenessSection: {
    // height: 370,
    overflow: "auto",
    padding: "0 10px",
  },
  disabledApp: {
    cursor: "not-allowed",
    opacity: "0.6",
  },
  referralCardPaperBlock: {
    position: "relative",
  },
  referralCardButton: {
    position: "absolute",
    top: "-70px",
    right: "5px",
  },
  pointsHeading: {
    "& h2 ": {
      fontSize: "20px",
      fontWeight: "600",
    },
  },
  lifetimePoints: {
    "& p": {
      color: "#2196f3",
      fontSize: "18px",
      fontWeight: "500",
    },
  },
  rewardPoints: {
    margin: " 10px  auto",
    maxWidth: "100%",
    width: "100px",
    background: "#2196f3",
    padding: "10px",
    borderRadius: "5px",

    "& p": {
      fontSize: "24px",
      fontWeight: "600",
      color: "#fff",
    },
  },
  achievementsBtn: {
    padding: "10px 15px ",
    border: "1px solid #17c5ad",
    textDecoration: "none",
    maxWidth: "100%",
    width: "160px",
    margin: "auto",
    boxShadow: "5px 4px 12px 0px #47d1beb0;",
    borderRadius: "20px",
    a: {
      textDecoration: "none",
      color: "#17c5ad",
      fontWeight: "600",
    },
  },
  leaderboardImage: {
    img: {
      width: "175px",
    },
  },
  responsiveContainerBar: {
    [theme.breakpoints.up("md")]: {
      width: 840,
    },
    [theme.breakpoints.down("md")]: {
      width: 380,
      position: " relative",
      left: "-45px",
    },
  },
  listItemTextPoints: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#000",
    fontWeight: "500",
    p: {
      color: "#000",
      fontSize: "18px",
    },
  },
  rankText: {
    fontWeight: "600",
  },
  // borderPaperblock:{
  //   border:"1px solid #0facc9",
  //   borderRadius:"7px",
  // }
  appListItem: {
    cursor: "pointer",
  },
  table: {
    "& > div": {
      overflow: "auto",
    },
    "& table": {
      "& td": {
        wordBreak: "keep-all",
      },
      [theme.breakpoints.down("lg")]: {
        "& td": {
          height: 60,
          overflow: "hidden",
          textOverflow: "ellipsis",
          paddingLeft: "8px",
        },
      },
    },
  },
  staticCardLogo: {
    height: "75px",
  },
  trainingSection: {
    display: "flex",
    alignItems: "center",
  },
  accordianModalHeadeing: {
    display: "flex ",
    alignItems: "center ",
    justifyContent: "space-between",
  },
  headingModalReward: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 10px",
  },
  rewardHeaderPointsCard: {
    display: "flex",
    justifyContent: "space-between",
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
  },
  gradientBtn: {
    // background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
    background: " rgb(156,39,176)",
    background:
      " linear-gradient(117deg, rgba(156,39,176,1) 0%, rgba(90,7,105,1) 48%, rgba(34,2,40,1) 80%)",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 48,
    padding: "0 10px",
    boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .30)",
  },
  rewardPointsValue: {
    fontSize: "20px",
    fontWeight: "800",
  },
  invalidUsersList: {
    textDecoration: "line-through",
  },
  invalidBulkUploadedCard: {
    height: "400px",
    overflowY: "auto",
  },
  currentApplication: {
    height: "230px !important",
    backgroundColor: "#2196f3",
  },
  currentApplicationCard: {
    height: "200px !important",
  },
  glamesProfileModalDialogBox: {
    width: "800px !important",
    [theme.breakpoints.down("lg")]: {
      width: "300px !important",
    },
  },
  containerSection: {
    [theme.breakpoints.down("lg")]: {
      display: "inline-flex",
    },
  },
  veticalContainer: {
    backgroundColor: "#0facc9",
  },
  iseaPapaerblock: {
    backgroundColor: "#0facc9",
    color: "#fff",
  },
  activityDetials: {
    // height: "100px ",
  },
  latestUpdates: {
    padding: "7px 10px",
    textAlign: "left",

    backgroundColor: "#6e56a4",

    // padding: 5px 10px;
    margin: "8px 0",

    "&>a": {
      color: "white",
      textDecoration: "none",
    },

    "& div": {
      color: "white",
    },
  },
  counterCardResource: {
    border: blue[500] + " 1px solid",
    borderRadius: 10,
    padding: "10px 15px",
    margin: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
    transition: "all 0.3s ease-in-out",
  },
  moreDetailsSection: {
    height: "110px",
    transition: "all 0.3s ease-in-out",
    // transition: "max-height 0.5s ease-in-out, opacity 0.5s ease-in-out",
  },
  moreDetailsButton: {
    display: "flex",
    justifyContent: "flex-start",
  },
  barIconDetails: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  highChartsPie: {
    boxShadow: "0 0 10px #badfef",
    padding: "40px 0 0 0 ",
    margin: "10px ",
  },
  cardMediaHeight: {
    height: "100%",
  },
  iseaAppCard: {
    display: "flex",
    flexDirection: "column",
    height: "100%", // important: fill grid item height
  },
  cardContent: {
    flexGrow: 1,
  },
  cardActions: {
    // optional fixed height or padding if needed
  },
  media: {
    height: 240, // fixed media height for consistent card header size
  },
  TrainingAppSectionScroller: {
    height: "450px",
    overflowY: "scroll",
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
